import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Unavailability } from 'src/app/shared/models/unavailability';
import { ConstantsService } from '../constant/constants.service';
import { GenericCrudService } from '../generic-crud.service';

@Injectable({
	providedIn: 'root'
})
export class UnavailabilityService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	deleteUnavailabilityById(
		unavailabilityId: number
	): Observable<HttpResponse<void>> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.unavailabilityUrl}/${unavailabilityId}`,
			`deleteUnavailabilityById`
		);
	}

	updateUnavailability(
		unavailability: Unavailability
	): Observable<Unavailability> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.unavailabilityUrl}`,
			`updateUnavailability`,
			unavailability
		);
	}

	postUnavailability(
		unavailability: Unavailability
	): Observable<Unavailability> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.unavailabilityUrl}`,
			`postUnavailability`,
			unavailability
		);
	}
}
